import React from 'react'

import {Colors} from '../../../components/UI/index.js'
import {BORDER, TEXT, PortalStyles} from './ui.js'

// Page shell: webshop logo on top of the content card and a return policy link below it
export default function PortalLayout({portal, color, children}) {
    return (
        <div className='rp-page' style={{height: '100vh', overflowY: 'auto', background: '#F6F7F9'}}>
            <PortalStyles color={color} />

            <div style={{maxWidth: 560, margin: '0 auto', padding: 'clamp(24px, 8vh, 72px) 16px 48px'}}>
                <div
                    style={{
                        background: Colors.white,
                        borderRadius: 16,
                        border: `1px solid ${BORDER}`,
                        padding: 'clamp(20px, 5vw, 36px)'
                    }}
                >
                    <div style={{display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 20, marginBottom: 28, borderBottom: `1px solid ${BORDER}`}}>
                        <img
                            src={portal?.logo ? `/${portal.logo}` : '/images/VELOYDLOGO.png'}
                            alt={portal?.customerName || 'Logo'}
                            style={{maxHeight: 40, maxWidth: 160, objectFit: 'contain'}}
                        />
                        <span style={{marginLeft: 'auto', fontSize: 13, color: TEXT.muted}}>Retourportaal</span>
                    </div>

                    {children}
                </div>

                {portal?.returnPolicyURL &&
                    <p style={{textAlign: 'center', margin: '20px 0 0', fontSize: 13, color: TEXT.muted}}>
                        {'Lees meer over het '}
                        <a target='_blank' rel='noreferrer' href={withHttp(portal.returnPolicyURL)} style={{color}}>retourbeleid</a>
                        {portal.customerName ? ` van ${portal.customerName}` : ''}
                    </p>
                }
            </div>
        </div>
    )
}

const withHttp = (url) => !/^https?:\/\//i.test(url) ? `http://${url}` : url
